export const LightCommunicationHubRoutes = [
    {
        "url": "/engagement-comms/:brand_id",
        "name": "light-communication-hub",
        "type": "frontend",
        "showGlobalSearch": false,
        "loginRequired": true,
        "params": {},
        "component": "lightCommsHubContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["light-communication-hub", "communication_hub_shared"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/light-communication-hub/light-communication-hub.downgrade.module");
                }
            },
            { type: "library", path: "../ext_libs/jwplayer/jwplayer.js" },
        ]
    },
    {
        "url": "?conversation_id&conversation_group_id",
        "name": "light-communication-hub.group",
        "type": "frontend",
        "showGlobalSearch": false,
        "loginRequired": true,
        "params": {},
        "views": {
            "body": {
                "component": "lchGroupConversationContainer",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["light-communication-hub", "communication_hub_shared"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/light-communication-hub/light-communication-hub.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/communication-hub/communication-hub.shared.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=light-communication-hub.routes.js.map